/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TextField, FormControl, InputLabel, Select, 
MenuItem, TableRow, Typography, Tabs, Tab, Divider, Dialog, List, ListItem, ListItemText, Collapse, ListSubheader, Accordion, AccordionSummary, AccordionDetails, Avatar, IconButton } from '@material-ui/core'

import { format } from 'date-fns'

import Actions from '../../fluid/Actions/ActionFactory'

import TrainingStage from '../IC/components/Operation/TrainingStage';
import Review from  './PIIReview/PIIReview.js';
import { Clear, CheckCircleOutline, ErrorOutline, ArrowBackIos, ExpandLess, ExpandMore, Folder, FolderOpenOutlined, FolderOpenRounded, FolderOutlined, ArrowBack } from '@material-ui/icons';
import PIIReview from './PIIReview/PIIReview.js';
import { Pagination } from '@material-ui/lab';
import { faLoveseat } from '@fortawesome/pro-duotone-svg-icons';

const AntTabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: '#1890ff',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#1890ff',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#40a9ff',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    headerStyle : {
        color : '#707070',
        backgroundColor : 'rgba(245,245,245,0)',
        fontSize : 11,
        border : 'none'
    }
})

class PII extends Component {
    state = {
      loading_data : false,
      loading_data_error : false,
      loading_data_error_message : null,
      selectedRowIndex : null,
      drl_url : null,
      all_ics : [],
      models : [],
      selected_ic : null,
      selected_wv_server_name : null,
      detecting : false,
      detect_error : false,
      redacting : false,
      redact_error : false,
      redact_output_folder : null,
      redact_redaction_type : null,
      show_review : false,
      selected_version : null,
      loading_versions : false,
      loading_versions_error : false,
      versions : null,
      loading_files : false,
      loading_files_error : false,
      files : null,
      folders : null,
      folder_count : null,
      file_count : null,
      curr_file_page : 1,
      curr_folder_page : 1,
      page_size : 20,
      selected_file : null,
      reactDialogOpen : false,
      open : {},
      selected_file : null,
      right_tab_index: 0,
    }
    
    componentDidMount () {
      Actions('http_request', {
        url : "/sainapse/data_rendering_service",
        method : 'get',
        data : {}
      }).then(res => {
          this.setState({...this.state, drl_url : res.data.result[0].url}, () => this.getPIIICs())
      }).catch(err => {

      })
    }

    getPIIICs = () => {
      this.setState({...this.state, loading_data : true}, () => {
          Actions('http_request', {
              url : "/sainapse/information_channel",
              method : "get",
              data : {}
          }).then(res => {
              let all_ics = res.data.result
              let pii_ics = all_ics.filter(ic => ic.operations.includes("PII"))
              this.setState({...this.state, loading_data : false, models : pii_ics, loading_data_error : false, loading_data_error_message : null}, () => console.log("Dedup State :", this.state))
          }).catch(err => {
              this.setState({...this.state, loading_data : false, loading_data_error : true, loading_data_error_message : "Error in getting PII ICs."})
          })
      })
    } 

    renderIRCs = () => {
      return (
          <div style = {{width  : '100%', height : 'calc(100vh - 50px)'}}>
              <Paper variant = 'outlined' square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                  <Typography style = {{fontSize : 20, fontWeight : 600}} variant = 'h6'>Intelligent Row Consolidation</Typography>
              </Paper>
              <div style = {{width : '100%', height : 'calc(100vh - 100px)', display : 'flex', flexDirection : 'row'}}>
                  <div style = {{width : '30%', height : '100%'}}>
                      {this.state.loading_data ? 
                      <div style = {{width : '100%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                          <CircularProgress variant = 'determinate' color = 'primary'/>
                      </div> : this.renderICs()}
                  </div>
              </div>
          </div>
      );
    }

    renderICs = () => {
      const { classes } = this.props
      return (
          <div style = {{width : '100%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
              <Paper square elevation = {0} style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                  <Typography variant = 'subtitle2'>Information Channels</Typography>
              </Paper>
              <div style = {{width : '100%', height : 'calc(100% - 50px)'}}>
                  <TableContainer
                      style = {{
                          width : '100%',
                          maxHeight : '100%'
                      }}
                  >
                      <Table
                          stickyHeader
                      >
                          <TableHead>
                              <TableRow>
                                  <TableCell
                                      // className = {classes.headerStyle}
                                  >Name</TableCell>
                                  <TableCell
                                      // className = {classes.headerStyle}
                                  >Status</TableCell>
                              </TableRow>
                          </TableHead>
                          <TableBody>
                              {this.state.models.map(model => {
                                  console.log('IRC :: Models :', model)
                                  return (
                                      <TableRow 
                                          style = {{width : '100%', backgroundColor : this.state.selected_ic === model.name ? '#EBF7FF' : '#FFFFFF', cursor : 'pointer'}}
                                          onClick = {() => {
                                              // let global_field_display_name = model.world_view.configs.find(config => config.operation === "IRC").config_params.global_record_identifier
                                              // let group_display_name = "Group"
                                              // let field_display_name = "Record"
                                              let selected_ic = this.state.selected_ic === model.name ? null : model.name
                                              console.log('Selected IC : ', selected_ic)
                                              let ic
                                              let redact_output_folder = null
                                              let redact_redaction_type = null
                                              if (selected_ic !== null){
                                                ic = model
                                                let ic_ops_config = ic.world_view.configs.find(op => op.operation === 'PII')
                                                redact_output_folder = ic_ops_config.config_params.redaction_path
                                                console.log('Output Folder : ', redact_output_folder)
                                                redact_redaction_type = ic_ops_config.config_params.redaction_type
                                                console.log('Redaction Type : ', redact_redaction_type)
                                              }
                                              this.setState(
                                                  {
                                                      ...this.state, 
                                                      selected_ic : this.state.selected_ic === model.name ? null : model.name,
                                                      selected_wv_server_name : this.state.selected_ic === model.name ? null : model.world_view.server,
                                                      redact_output_folder : redact_output_folder,
                                                      redact_redaction_type : redact_redaction_type,
                                                      selected_version : null
                                                  }, () => this.getVersions()
                                                )
                                              }}
                                      >
                                          <TableCell>{model.name}</TableCell>
                                          <TableCell>{this.renderPIIOperationStatus(model)}</TableCell>
                                      </TableRow>
                                  )
                              })}
                          </TableBody>
                      </Table>
                  </TableContainer>
              </div>
          </div>
      )
    }


    renderPIIOperationStatus = (ic_data) => {
      let ic_op = ic_data.operations.filter(op => op === "PII")
      let operation = ic_op.map(op =>  <TrainingStage size = 'small' ic = {ic_data} op = {op} refresh = {this.getPIIICs} interaction = {false}/>)
      console.log('IC OP :', operation)
      return operation
    }

    isDetectable = () => {
      let ic = this.state.models.find(ic => ic.name === this.state.selected_ic)
      let detection_status = ic.operation_status.pii_detect_status
      if (detection_status === 'Queued' || detection_status === 'InProgress') {
        return false
      } else {
        return true
      }
    }

    isRedactable = () => {
      let ic = this.state.models.find(ic => ic.name === this.state.selected_ic)
      let redaction_status = ic.operation_status.pii_redact_status
      if (redaction_status === 'Queued' || redaction_status === 'InProgress') {
        return false
      } else {
        return true
      }
    }

    getFiles = () => {
      if(this.state.selected_ic !== null && this.state.selected_version !== null) {
        this.setState({...this.state, loading_files : true, loading_files_error : false}, () => {
          Actions('http_request', {
            url : '/sainapse/pii/folder_metadata/?ic_name=' + this.state.selected_ic,
            method : "post",
            data : {}
          }).then(res => {
              console.log("pii :: Files : ", res.data.result)
              // let open = {}
              // res.data.result.folders.map((folder) => {
              //   open[folder.name] = false
              // })
              this.setState({...this.state, files: res.data.result, file_count: res.data.result.file_count, folder_count: res.data.result.folder_count}, () => {
                Actions('http_requests', [
                  {
                    url : '/sainapse/pii/folder_structure',
                    method : "post",
                    data : {
                      ic_name: this.state.selected_ic,
                      limit: 20,
                      offset: 0
                    }
                  },
                  {
                    url : '/sainapse/pii/files',
                    method : "post",
                    data : {
                      ic_name: this.state.selected_ic,
                      limit: 20,
                      offset: 0
                    }
                  },
                ]).then(res => {
                    this.setState({...this.state, loading_files : false, loading_files_error : false, folders: res[0].data.result.folders, files: res[1].data.result.files})
                }).catch(err => {

                })
              })
          }).catch(err => {
              this.setState({...this.state, loading_files : false, loading_files_error : true, files: null})
          })
        })
      }
    }

    renderTabContent = () => {
        if (this.state.right_tab_index === 0) {
            return this.renderFolders(this.state.files)
        } else {
            return this.renderFiles(this.state.files)
        }
    }

    renderTabs = () => {
      return(
          <AntTabs
              style={{ flexGrow: 1}}
              value={this.state.right_tab_index}
              indicatorColor="primary"
              textColor="primary"
              variant = 'scrollable'
              scrollButtons="auto"
              onChange = {(event, newValue) => this.setState({...this.state, right_tab_index : newValue})}
          >
              <AntTab label = 'Folders'/>
              <AntTab label = 'Files' />
          </AntTabs>
      )
    }

    renderPIIFiles = () => {
      return(
        <div style={{width: '100%', height: '100%'}}>
          <Paper square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
            <IconButton size = 'small' onClick = {() => {this.setState({...this.state, selected_version : null})}}>
              <ArrowBack fontSize='inherit'/>
            </IconButton>
            <Typography variant = 'subtitle2' style={{ flexGrow : 1, marginLeft: '5px'}}> Version: {this.state.selected_version}</Typography>
          </Paper>
            {this.renderTabs()}
            <div style={{width: '100%', height: 'calc(100% - 100px)'}}>
            {this.renderTabContent()}
            </div>
        </div>
      )
    }

    folderPageChange =(value) => {
      console.log("Page Changed : ", value)
      let offset = ((value-1) * this.state.page_size) + 1
      let limit = this.state.page_size + offset - 1
      this.setState({...this.state, loading_files: true, loading_files_error: false}, () => {
        Actions('http_request',{
          url : '/sainapse/pii/folder_structure',
          method : "post",
          data : {
            ic_name: this.state.selected_ic,
            limit: limit,
            offset: offset
          }
        }).then(res => {
          this.setState({...this.state, curr_folder_page : value, folders: res.data.result.folders, loading_files: false, loading_files_error: false})
        }).catch(err => {
          this.setState({...this.state, loading_files: false, loading_files_error: true, folders: null})
        })
      })
    }
    
    renderFolders = (files) => {
      return (
        < div style={{ width : '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', overflow: 'auto'}}>
          {/* <Paper square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
            <IconButton size = 'small' onClick = {() => {this.setState({...this.state, selected_version : null})}}>
              <ArrowBack fontSize='inherit'/>
            </IconButton>
            <Typography variant = 'subtitle2' style={{ flexGrow : 1, marginLeft: '5px'}}> Version: {this.state.selected_version}</Typography>
          </Paper>
          <div style={{ width : '100%'}}>
            <Paper square elevation = {0} style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px'}}>
                <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>Folders:</Typography>
            </Paper> */}
            {(this.state.loading_files) && <div style = {{width : '100%', padding : '50px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                  <CircularProgress variant = 'indeterminate' color = 'primary'/>
              </div>}
            <div style={{ display: 'flex', flexDirection: 'column'}}>
              {!this.state.loading_files && this.state.folders !==null && this.state.folders.map((folder)=> {
                return (
                  <Accordion square elevation={0} variant = 'outlined' style = {{ width : '100%'}}>
                    <AccordionSummary  style = {{width : '100%'}} expandIcon = {<ExpandMore fontSize = 'small'/>}>
                      <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <FolderOutlined fontSize='small' style={{ marginRight : '5px'}}/>
                        <Typography variant='body1' style={{ width : '100%'}}>{folder.name}</Typography>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div style = {{width : '100%',height: '100%', display : 'flex', flexDirection : 'column'}}>
                        {folder.files.map((file) => {
                          return (
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'row', borderBottom : '1px solid rgba(0,0,0,0.12)', padding : '5px'}}>
                              <Typography variant='body2' style={{ width : '100%'}}>{file.name}</Typography>
                              <div style = {{ marginRight : '10px', marginLeft : 'auto'}}>
                                <Button
                                  size = 'small'
                                  color = 'primary'
                                  onClick = {(e) =>  {e.stopPropagation(); this.handleClick(file)}}
                                >Review</Button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                )
              })}
            </div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', marginBottom: '10px', marginTop: '10px'}}>
              <Pagination 
                count={Math.ceil(this.state.folder_count / this.state.page_size)} 
                shape='rounded' 
                page={this.state.curr_folder_page} 
                onChange={(event,value) => this.folderPageChange(value)}
                size='small'
              />
            </div>
            {/* {files && files.files.map((file) => {
              return (
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', borderBottom : '1px solid rgba(0,0,0,0.12)', padding : '5px', marginLeft : '5px'}}>
                  <Typography variant='body2' style={{ width : '100%'}}>{file.name}</Typography>
                  <div style = {{ marginRight : '10px', marginLeft : 'auto'}}>
                    <Button
                      size = 'small'
                      color = 'primary'
                      onClick = {(e) =>  {e.stopPropagation(); this.handleClick(file)}}
                    >Review</Button>
                  </div>
                </div>
              );
            })}
          </div> */}
        </div>
      )
    }

    filePageChange = (value) => {
      console.log("Page Changed : ", value)
      let offset = ((value-1) * this.state.page_size) + 1
      let limit = this.state.page_size + offset - 1
      this.setState({...this.state, loading_files: true, loading_files_error: false}, () => {
        Actions('http_request',{
          url : '/sainapse/pii/files',
          method : "post",
          data : {
            ic_name: this.state.selected_ic,
            limit: limit,
            offset: offset
          }
        }).then(res => {
          this.setState({...this.state, curr_file_page : value, files: res.data.result.files, loading_files: false, loading_files_error: false})
        }).catch(err => {
          this.setState({...this.state, loading_files: false, loading_files_error: true, files: null})
        })
      })
    }

    renderFiles = (files) => {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', width : '100%', height : '100%', justifyContent: 'space-between', overflow: 'auto'}}>
          {
              (this.state.loading_files) && <div style = {{width : '100%', padding : '50px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                  <CircularProgress variant = 'indeterminate' color = 'primary'/>
              </div>
          }
          <div style={{width: '100%', flex: 'column', flexDirection: 'column'}}>
            { (!this.state.loading_files && this.state.files !== null) && this.state.files.map((file) => {
              return (
                <Accordion square elevation={0} variant = 'outlined' style = {{ width : '100%'}}>
                  <AccordionSummary  style = {{width : '100%'}}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row'}}>
                      <Typography variant='body2' style={{ width : '100%'}}>{file.name}</Typography>
                      <div style = {{ marginRight : '10px', marginLeft : 'auto'}}>
                        <Button
                          size = 'small'
                          color = 'primary'
                          onClick = {(e) =>  {e.stopPropagation(); this.handleClick(file)}}
                        >Review</Button>
                      </div>
                  </div>
                  </AccordionSummary>
                </Accordion>
              );
            })}
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', marginBottom: '10px', marginTop: '10px'}}>
            <Pagination 
              count={Math.ceil(this.state.file_count / this.state.page_size)} 
              shape='rounded' 
              page={this.state.curr_file_page} 
              onChange={(event,value) => this.filePageChange(value)}
              size='small'
            />
          </div>
        </div>
      )
    }
    
    handleClick = (file) => {
      this.setState({...this.state, show_review : true, selected_file : file}, () => console.log("show_review state ::", this.state.show_review))
      //this.setState({...this.state, report_version : version, show_review : true })
    }

    getVersions = () => {
        if (this.state.selected_ic !== null) {
            this.setState({...this.state, loading_versions : true, loading_versions_error : false}, () => {
                Actions('http_request', {
                    url : "/sainapse/pii/version_info",
                    method : "post",
                    data : {
                        ic_name : this.state.selected_ic
                    }
                }).then(res => {
                    console.log("pii :: Versions : ", res.data.result)
                    this.setState({...this.state, loading_versions : false, loading_versions_error : false, versions: res.data.result.Result})
                }).catch(err => {
                    this.setState({...this.state, loading_versions : false, loading_versions_error : true, versions: null})
                })
            })
        }
    }

    renderVersions = () => {
        return (
            <div style = {{width : '100%', height : '100%' }}>
                <Paper square elevation = {0} style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>PII Report Versions</Typography>
                </Paper>
                {
                    (this.state.loading_versions) && <div style = {{width : '100%', padding : '50px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <CircularProgress variant = 'indeterminate' color = 'primary'/>
                    </div>
                }
                {this.isDetectable() && !this.state.loading_versions && this.state.versions !== null && <div style = {{width : '100%', height : 'calc(100% - 50px)'}}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Version</TableCell>
                                    <TableCell>User ID</TableCell>
                                    <TableCell>Source Version</TableCell>
                                    <TableCell>Created On</TableCell>
                                    <TableCell>Completed On</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell align = 'center'>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.versions.map(ver => {
                                    return (
                                        <TableRow>
                                            <TableCell>{ver.version}</TableCell>
                                            <TableCell>{ver.uid}</TableCell>
                                            <TableCell>{ver.source_version}</TableCell>
                                            <TableCell>{format(new Date(ver.begin_timestamp), "yyyy-MM-dd HH:mm:ss.SSSxxx")}</TableCell>
                                            <TableCell>{ver.end_timestamp !== null ? format(new Date(ver.end_timestamp), "yyyy-MM-dd HH:mm:ss.SSSxxx") : null}</TableCell>
                                            <TableCell>{ver.status}</TableCell>
                                            <TableCell>{ver.status === 'Complete' ? 
                                                <div style={{ display : 'flex', alignItems : 'center', flexDirection : 'column'}}>
                                                  <Button
                                                        size = 'small'
                                                        color = 'primary'
                                                        onClick = {() => {this.createNewVersion(ver.version)}}
                                                    >New Version</Button>
                                                    <Button
                                                        size = 'small'
                                                        color = 'secondary'
                                                        onClick = {() => {this.setState({...this.state, reactDialogOpen : true})}}
                                                    >Redact</Button>
                                                </div>:
                                                <div style={{ display : 'flex', alignItems : 'center', flexDirection : 'column'}}>
                                                  <Button
                                                      size = 'small'
                                                      color = 'primary'
                                                      onClick = {() => {this.setState({...this.state, selected_version : ver.version}, () => this.getFiles())}}
                                                  >View Files</Button>
                                                  <Button
                                                      size = 'small'
                                                      color = 'secondary'
                                                      onClick = {() => {this.completeReview(this.state.selected_ic, ver.version)}}
                                                  >
                                                      Complete
                                                  </Button>
                                                </div>
                                            }</TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>}
            </div>
        )
    }

    createNewVersion = (version) => {
        Actions('http_request', {
            url : "/sainapse/pii/review_start",
            method : "post",
            data : {
                ic_name : this.state.selected_ic,
                version : version
            }
        }).then(res => {
            this.getVersions()
        }).catch(err => {

        })
    }

    completeReview = (ic_name, version) => {
        Actions('http_request', {
            url : "/sainapse/pii/review_complete",
            method : "post",
            data : {
                ic_name : ic_name,
                version : version
            }
        }).then(res=> {
            this.getVersions()
        }).catch(err => {

        })
    }

    renderPIIDetails = () => {
      return (
        <div>
          <Paper square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
            <Typography variant = 'h6' style={{ flexGrow : 1}}>{this.state.selected_ic}</Typography>
            <Button
              color='primary'
              variant = 'contained'
              size = 'small'
              disabled = {!this.isDetectable()}
              onClick = {this.piiDetect}
            >{this.isDetectable()? 'Detect' : 'InProgress'}</Button>
          </Paper>
          {this.renderVersions()}
        </div>
      )
    }

    renderRedactDialog = () => {
      return(
        <Dialog open={this.state.reactDialogOpen} onClose = {() => this.setState({...this.state, reactDialogOpen : false})}>
          <Typography style = {{ margin: '10px'}} variant = 'subtitle2'>Redaction: </Typography>
          <div style = {{margin : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', width : '400px'}}>
            <TextField
              size='small'
              style = {{marginRight : '10px', flexGrow : 1}}
              id = 'redaction-path'
              label="Output Folder"
              defaultValue={this.state.redact_output_folder}
              value = {this.state.redact_output_folder}
              onChange={(event) => {
                this.setState({...this.state, redact_output_folder : event.target.value})
              }}
            />
            <FormControl size='small' style = {{marginRight : '10px', flexGrow : 1}}>
              <InputLabel id="redaction-type">Redaction Type</InputLabel>
              <Select
                size = 'small'
                labelId="redaction-type-select"
                id="redaction-type-select"
                value={this.state.redact_redaction_type}
                onChange={(event) => this.setState({...this.state, redact_redaction_type : event.target.value})}
              >
                <MenuItem value={null}>
                  <em>None</em>
                </MenuItem>
                <MenuItem value={'Highlight'}>Highlight</MenuItem>
                <MenuItem value={'Redact'}>Redact</MenuItem>
              </Select>
            </FormControl>
          </div>
          {this.state.redact_error && <Typography style = {{marginLeft: '10px', color : '#F50157'}} variant = 'caption'>Redact output folder cannot be empty</Typography>}
          <div style={{ alignItems : 'right', display : 'flex', flexDirection : 'row-reverse', padding : '5px'}}>
            <Button
                color='primary'
                variant = 'contained'
                disabled = {!this.isRedactable()}
                onClick={this.piiRedact}
              >Redact</Button>
          </div>
        </Dialog>
      );
    }

    piiDetect = () => {
      Actions('http_request', {
        url : '/sainapse/pii/detect',
        method : 'post',
        data : {
          ic_name : this.state.selected_ic
        }
      }).then(res => {
        this.getVersions()
      }).catch(err => {

      })
    }

    piiRedact = () => {
      if(this.state.redact_output_folder !== null && this.state.redact_output_folder !== "") {
        Actions('http_request', {
          url : '/sainapse/pii/redact',
          method : 'post',
          data : {
            ic_name : this.state.selected_ic,
            output_folder : this.state.redact_output_folder,
            redaction_type : this.state.redact_redaction_type,
            version : 0
          }
        }).then(res => {
          this.getVersions()
        }).catch(err => {
  
        })
      } else {
        this.setState({...this.state, redact_error : true})
      }
    }

    renderReview = () => { 
      console.log("DRL URL ::", this.state.drl_url)
      if(this.state.show_review) {
        return (
          <Review
            drl_url = {this.state.drl_url}
            file = {this.state.selected_file}
            wv_server = {this.state.selected_wv_server_name}
            ic_name = {this.state.selected_ic}
            version = {this.state.selected_version}
            close_review = { () => { this.setState({...this.state,show_review : false})}}
          />
        );
      }
    }

    renderPIIs = () => {
      return (
        <ThemeProvider theme = {blue_theme}>
          <div style = {{width  : '100%', height : 'calc(100vh - 50px)'}}>
              <Paper variant = 'outlined' square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                  <Typography style = {{fontSize : 20, fontWeight : 600}} variant = 'h6'>PII Detection</Typography>
              </Paper>
              <div style = {{width : '100%', height : 'calc(100vh - 100px)', display : 'flex', flexDirection : 'row'}}>
                  <div style = {{width : '30%', height : '100%'}}>
                      {this.state.loading_data ? 
                      <div style = {{width : '100%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                          <CircularProgress variant = 'determinate' color = 'primary'/>
                      </div> : this.renderICs()}
                  </div>
                  <div style = {{width : '70%', height : '100%'}}>
                      {this.state.selected_ic !== null ? this.state.selected_version !== null ? this.renderPIIFiles() : this.renderPIIDetails() : null}
                  </div>
              </div>
          </div>
        </ThemeProvider>
      );
    }

    render() { 
        return (
          <ThemeProvider theme = {blue_theme}>
            <div style={{ width : '100%', height : 'calc(100vh - 50px'}}>
              {this.state.show_review ? this.renderReview() : this.renderPIIs()}
              {this.state.reactDialogOpen ? this.renderRedactDialog() : null}
            </div>  
          </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(PII);